import InternalLayout, { Content, Footer, Header } from './layout';
import Sider from './Sider';
var Layout = InternalLayout;
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
Layout.Sider = Sider;
export default Layout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/layout/index.js
// module id = 957
// module chunks = 0